import { useMediaQuery } from '@mantine/hooks';
import { CheeseIcon } from './CheeseIcon';
import { CoinIcon } from './CoinIcon';

type BrickType = 'BRICK' | 'MINE' | 'UNKNOWN';

export type BrickIconProps = {
  type: BrickType;
  'data-test-id'?: string;
};

export const BrickIcon = ({
  type,
  'data-test-id': dataTestId,
}: BrickIconProps) => {
  const isSmallScreen = useMediaQuery('(max-width: 48em)');
  const iconSize = isSmallScreen ? 24 : 32;

  if (type === 'BRICK') {
    return (
      <CoinIcon
        data-test-id={dataTestId}
        data-type="coin"
        h={iconSize}
        w={iconSize}
        withAnimation
      />
    );
  }

  if (type === 'MINE') {
    return (
      <CheeseIcon
        data-test-id={dataTestId}
        data-type="cheese"
        h={iconSize}
        w={iconSize}
        withAnimation
      />
    );
  }

  return null;
};
